/**
 * Aplicar máscara de telefone/celular brasileiro.
 * Exemplos:
 * 67996268186 => (67) 99626-8186
 * 6733334444  => (67) 3333-4444
 */
export default function formatPhone(value = '') {
  const digits = `${value}`.replace(/\D/g, '').slice(0, 11)

  if (!digits) {
    return ''
  }

  const areaCode = digits.slice(0, 2)
  const local = digits.slice(2)

  if (digits.length <= 2) {
    return `(${areaCode}`
  }

  if (local.length <= 4) {
    return `(${areaCode}) ${local}`
  }

  if (local.length <= 8) {
    const prefix = local.slice(0, local.length - 4)
    const suffix = local.slice(-4)

    return `(${areaCode}) ${prefix}-${suffix}`
  }

  const prefix = local.slice(0, 5)
  const suffix = local.slice(5, 9)

  return `(${areaCode}) ${prefix}-${suffix}`
}
